import React from 'react';

import './CardDetail.scss';

/**
 * Component for showing a detail for ZealStream subscription plan on a Bootstrap 5 card
 *
 * @component
 * @example
 * const detail = "blah blah blah"; // detail can be any string
 * return (
 *   <PickerCardDetail detail={detail} />
 * )
*/

const PickerCardDetail = ({detail}) => {

    return (
        <p className="d-flex align-items-center">
            <span className="checkmark-container me-2 p-1">
                <img className="checkmark" src="/images/checkmark.svg" alt="checkmark" />
            </span>
            <span>{detail}</span>
        </p>
    );

}

export default PickerCardDetail;